import apiClient from './client.js';
const base = (wsId) => `/workspaces/${wsId}/ai`;
export const listProviders = (wsId) => apiClient.get(`${base(wsId)}/providers`).then(r => r.data);
export const getProviderCatalog = (wsId) => apiClient.get(`${base(wsId)}/providers/catalog`).then(r => r.data);
export const createProvider = (wsId, dto) => apiClient.post(`${base(wsId)}/providers`, dto).then(r => r.data);
export const updateProvider = (wsId, id, dto) => apiClient.patch(`${base(wsId)}/providers/${id}`, dto).then(r => r.data);
export const deleteProvider = (wsId, id) => apiClient.delete(`${base(wsId)}/providers/${id}`).then(r => r.data);
export const getUsage = (wsId) => apiClient.get(`${base(wsId)}/usage`).then(r => r.data);
export const copilot = (wsId, dto) => apiClient.post(`${base(wsId)}/copilot`, dto).then(r => r.data);
export const logRequest = (wsId, dto) => apiClient.post(`${base(wsId)}/requests/log`, dto).then(r => r.data);
